export let life = {
  mounted () {
    this.methods('clickFirst')
  },
  updated () {
    this.methods('clickFirst')
  }
}
export let event = {}
export let watch = {}
